<!--
Author: TangChen
Date: 2018-10-24
Desc: 现金宝持有明细，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-currency-hold bizcomp ' + className">
        <comp-title :title="title" />
        <el-table :data="tableData" style="width: 100%" class="tab-list-tit">
            <el-table-column prop="totalasset" label="持有金额（元）" align="center" class-name="red" :formatter="formatter" />
            <el-table-column prop="availablevol" label="可用金额（元）" align="center" :formatter="formatter" />
            <el-table-column prop="frozenvol" label="冻结金额（元）" align="center" :formatter="formatter" />
            <el-table-column label="银行卡" align="center">
                <template slot-scope="scope">
                    <div class="bank-img-sel list-bank">
                        <img v-if="ZX_CENTER_ID!==scope.row.paycenterid" :src="$util.getImg(scope.row.bankid)">
                        <span class="k-text-flow">{{ ZX_CENTER_ID!==scope.row.paycenterid?$cache.getDict('150003',scope.row.bankid):$cache.getDict('110079',scope.row.paycenterid) }}</span>
                        <i class="paycenter">{{ $cache.getDict('110079',scope.row.paycenterid) }}</i>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "CurrencyHold",
    mixins: [mixin],
    data () {
        return {
            tableData: [],
            ZX_CENTER_ID: ""// 柜台渠道号
        };
    },
    mounted () {
        this.getXjbHoldInfo();
        this.ZX_CENTER_ID = this.$util.getConfig().const.ZX_CENTER;
    },
    methods: {
    // 获取现金宝信息
        getXjbHoldInfo () {
            this.$util.request("xjb/query/assetdetail").then(res => {
                if (res.data) {
                    this.tableData = res.data;
                }
            });
        },
        formatter (row, column, value) {
            return this.$util.fmtNum(value);
        }
    }
};
</script>
